import { useState } from "react"
import * as React from "react"
import { Grid, Typography, Button, TextField } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { useNavigate } from "react-router"
import { useForm } from "react-hook-form"
import { useApp } from "../../AppProvider"
import { login } from "./services/api"
import { ROLES } from "../sidebar/constants"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import loginImage from "../../assets/login_image.svg"
import sessionGif from "../../assets/gif-recortado.gif"
import logoStock from "./../../assets/spinmovilFullLogo.svg"
import fondoLogin from "./../../assets/fondoLogin.png"
import { email_regex } from "../../helpers/regular_expressions"
import "./index.css"
import PrimaryButton from "../../components/PrimaryButton"

const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    backgroundColor: "#FFFFFF",
    fontFamily: "Ubuntu, sans-serif",
  },
  loginIcon: {
    width: "100%",
    height: "100%",
    background: "rgba(6 153 226)",
    objectFit: "cover",
  },
  phoneImage: {
    position: "absolute",
    height: "80%",
    marginRight: "8%",
  },
  titleText: {
    color: "#F5F5F5",
    margin: 0,
    fontWeight: "400",
    fontFamily: "Ubuntu, sans-serif",
    fontSize: "35px",
    "& b": {
      color: "#1BC3DD",
      fontWeight: "700",
    },
    "& strong": {
      color: "#F5F5F5",
      margin: 0,
      fontWeight: "700",
      fontFamily: "Ubuntu, sans-serif",
      fontSize: "35px",
    },
    ["@media (max-width: 1370px)"]: {
      fontSize: 30,
    },
  },

  baseFrame: {
    height: "auto",
    width: "36.5%",
    ["@media (max-width: 1300px)"]: {
      width: "30%",
    },
    ["@media (max-width: 1200px)"]: {
      width: "25%",
    },
  },
  formInput: {
    "& .MuiInputBase-root": {
      height: "50px !important",
      width: "373px !important",
    },
    "& .MuiInputLabel-root": {
      color: "#000000 ",
      fontFamily: "Ubuntu",
      fontSize: "16px !Important",
    },
    "& .Mui-focused": {
      color: "#000000 !important",
    },
    "& .Mui-error": {
      color: "#d32f2f !important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderRadius: "8px",
        borderColor: "#4E5589",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#4E5589",
      },
      "&.Mui-error fieldset": {
        borderColor: "#d32f2f",
      },
    },
  },
  esmsLogo: {
    width: "320px",
    marginBottom: "2% !important",
    ["@media (max-width: 1300px)"]: {
      width: "15vw",
    },
  },
  
}))

const Login = () => {
  const navigate = useNavigate()
  const classes = useStyles()
  const { setCurrentUser, showNotification } = useApp()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const { email: emailError, password: passwordError } = errors
  const [showPassword, setShowPassword] = useState(false)

  const onSubmit = async ({ email, password }) => {
    try {
      const response = await login(email, password)
      localStorage.setItem(
        "conectium-esms-admin-token",
        response.data.access_token
      )
      localStorage.setItem(
        "current-esms-user",
        JSON.stringify(response.data.user)
      )
      setCurrentUser(response.data.user)

      navigate("/home")
    } catch (err) {
      if (err.response) {
        switch (err.response.status) {
          case 403:
            showNotification(
              "Tu usuario no ha sido verificado. Comunícate con el administrador para crear tus credenciales de acceso",
              "error"
            )
            break
          case 406:
            showNotification(
              "Lo sentimos, su usuario no tiene acceso. Por favor, comuníquese con el administrador.",
              "error"
            )
            break
          default:
            showNotification(
              "Lo sentimos, la combinación de correo electrónico y contraseña no es válida",
              "error"
            )
            break
        }
      } else {
        showNotification(
          "Lo sentimos, ha ocurrido un error inesperado",
          "error"
        )
      }
    }
  }

  const greenButton = {
    borderColor: "#4E5589",
    textTransform: "none",
    borderWidth: "2px",
    borderRadius: "8px",
    color: "#4E5589",
    height: "53px",
    "&:hover": {
      /* background: " linear-gradient( #008C0D 33.74%, #00BF19 96.06%);", */
      background: "#4E5589",
      boxShadow:
        "0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)",
      color: "white",
      borderRadius: "8px",
    },
  }

  return (
    /*     <Fade in={true} timeout={1000}> */
    <Grid
      container
      className={classes.root}
      justifyContent="center"
      alignItems="center"
    >
      <img className={classes.phoneImage} src={sessionGif} alt="" />
      <Grid
        item
        xs={5.4}
        sm={5.4}
        md={5.4}
        sx={{
          height: "100vh",
          display: "flex",
          backgroundImage: `url(${fondoLogin})`,
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div style={{ width: "100%", padding: "33.7% 28% 0px 15%" }}>
          <p className={classes.titleText}>
            ¡<strong>Conecta</strong> con tus clientes! <br />
            <br />
            <b>Envía</b> tus campañas{" "}
            <strong>
              por <br /> SMS{" "}
            </strong>{" "}
            de forma{" "}
            <b>
              {" "}
              rápida y <br />
              segura
            </b>
            .
          </p>
        </div>
      </Grid>
      <Grid
        item
        className={classes.baseFrame}
        xs={6.6}
        sm={6.6}
        md={6.6}
        container
        direction="column"
        alignItems="end"
        padding="0 7.15% 0 0"
      >
        <Grid item textAlign="center" width="25vw">
          <img alt="andromeda" src={logoStock} className={classes.esmsLogo} />
        </Grid>

        <Grid
          item
          width="25vw"
          style={{
            textAlign: "center",
            marginBottom: "5%",
            letterSpacing: "0.15px",
            fontFamily: "Ubuntu, sans-serif",
            fontSize: "24px",
            lineHeight: "24px",
          }}
        >
          <p>Iniciar sesión</p>
        </Grid>
        <Grid item direction="column" alignItems="center">
          <form onSubmit={handleSubmit(onSubmit)} style={{ width: "25vw" }}>
            <Grid
              item
              container
              direction="column"
              alignItems="center"
              spacing={2}
            >
              <Grid item container justifyContent="center">
                <TextField
                  className={classes.formInput}
                  sx={{
                    marginBottom: "37px !important",
                  }}
                  id="email"
                  label="Correo electrónico"
                  variant="outlined"
                  helperText={emailError?.message}
                  error={emailError !== undefined}
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Campo obligatorio",
                    },
                    pattern: {
                      value: email_regex,
                      message: "Correo electrónico inválido",
                    },
                    validate: {
                      rangeLength: (value) =>
                        value.split("@")[0].length <= 64 ||
                        "Correo electrónico inválido",
                    },
                  })}
                />
              </Grid>
              <Grid item container justifyContent="center">
                <TextField
                  className={classes.formInput}
                  id="password"
                  label="Contraseña"
                  type={showPassword === false ? "password" : "text"}
                  variant="outlined"
                  helperText={passwordError?.message}
                  error={passwordError !== undefined}
                  InputProps={{
                    endAdornment: (
                      <Button
                        sx={{ display: "flex", justifyContent: "end" }}
                        onClick={() => {
                          setShowPassword(!showPassword)
                        }}
                      >
                        {showPassword === false ? (
                          <Visibility style={{ color: "rgba(0, 0, 0, 0.6)" }} />
                        ) : (
                          <VisibilityOff
                            style={{ color: "rgba(0, 0, 0, 0.6)" }}
                          />
                        )}
                      </Button>
                    ),
                  }}
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Campo obligatorio",
                    },
                    maxLength: {
                      value: 15,
                      message:
                        "La contraseña supera el límite de caracteres permitidos",
                    },
                    minLength: {
                      value: 6,
                      message:
                        "La contraseña no cumple con el mínimo de caracteres",
                    },
                  })}
                />
              </Grid>
              <Grid item container justifyContent="flex-end" width="373px">
                <Typography
                  sx={{
                    fontFamily: "Ubuntu, sans-serif",
                    fontWeight: "bold",
                    fontSize: "11px",
                    lineHeight: "24px",
                    letterSpacing: "0.15px",
                    color: "#363636",
                    marginBottom: "1%",
                    "&:hover": {
                      cursor: "pointer",
                    },
                  }}
                  onClick={() => {
                    navigate("/recover-password")
                  }}
                >
                  ¿Olvidaste tu contraseña?
                </Typography>
              </Grid>
              <Grid item container justifyContent="center">
                <PrimaryButton width="373px" height="53px" action={() => {}} text="Ingresar" fontSize="20" type="submit">
                  
                </PrimaryButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
    /*  </Fade> */
  )
}

export default Login
